import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import CurvedContainer from '../../components/CurvedContainer';
import { Wrapper } from '../../components';
import { useActions } from 'hooks/useActions';
import { Images } from 'util/images';
import * as actions from './actions';
import { UnsubscribeContainer } from './styles';
import { Spinner } from 'components/Spinner/spinner';

export default React.memo(() => {
  const { id } = useParams();

  let { unsubscribeUser } = useActions(actions);
  let { isUnsubscribed, loading } = useSelector((state) => state.unsubscribe);

  useEffect(() => {
    unsubscribeUser(id);
  }, [unsubscribeUser, id]);

  return (
    <Wrapper>
      <CurvedContainer bottom image={Images.art} height={110} />
      {loading && <Spinner />}
      {isUnsubscribed && <UnsubscribeContainer>You are now unsubscribed!</UnsubscribeContainer>}
      {!loading && !isUnsubscribed && <UnsubscribeContainer>Failed to unsubscribe!</UnsubscribeContainer>}
    </Wrapper>
  );
});
